module.exports = __webpack_public_path__ + "static/media/tableros.795ca662.webp";